import React, {Component, Fragment} from 'react';
import {observer,inject} from "mobx-react";
import {toJS} from "mobx";
import fuzzer from "../../../utils/fuzzer";
import AutosizeInput from 'react-input-autosize';
import {StoreContext} from "../../../stores/contexts";

class ListSelector extends Component {
  static contextType = StoreContext;

  constructor(props) {
    super(props);
    this.state={
      add_field:0,
      search:'',
      selected_value:null,
      fields:props.fields,
      filtered_fields:[],
      select_index:-1,
      sel_setted:null,
      sel_fetching:false,
    };
  }
  componentDidMount() {
    if(!this.props.filterFunction) {
      this.setState({filtered_fields: this.state.fields});
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if(this.props.selected_value !== this.state.selected_value) {
      this.setState({ selected_value: this.props.selected_value });
    }
    if(this.props.fields && this.props.fields.length !== this.state.fields.length ) {
      this.setState({ fields:this.props.fields, filtered_fields:this.props.fields });
    }
    if(this.state.selected_value && this.state.selected_value!==prevState.selected_value) {
      if (this._autosizeInputRef) {
        console.log('fire ref _autosizeInputRef');
        this.inputRef(this._autosizeInputRef);
      }

    }

    if(prevState.search !== this.state.search) {
      if(this.state.search) {
        if(this.props.filterFunction) {
          this.setState({ fetching:true });
          this.props.filterFunction(this.state.search,(items)=>{
            this.setState({ filtered_fields: items, select_index:-1, fetching:false });
          });
        } else {
          const keys=[];

          if(this.props.search_fields) {
            this.props.search_fields.forEach((item)=>{
              keys.push({ key:item, weight: 0.6 });
            });
          }
          keys.push({key: "name", weight: 0.6});
          keys.push({key: "code", weight: 0.6});

          const filteredList = fuzzer(
            {data: this.state.fields},
            this.state.search,
            {
              key: keys,
              usePathScoring: true,
            }
          );
          this.setState({ filtered_fields: filteredList,select_index:-1 });
        }


      } else {
        this.setState({ filtered_fields: this.state.fields || [], select_index:-1 });
      }
    }
  }
  getIdField() {
    return this.props.idField || "value";
  }
  getTitleField() {
    return this.props.titleField || "name";
  }
  selectItem(item) {
    if(item) {
      this.setState({ selected_value: item[this.getIdField()] })
      if(this._autosizeInputRef) {
        this.inputRef(this._autosizeInputRef);
      }
      this.props.onSelect(item);
    } else {
      this.setState({ selected_value: null })
      this.props.onSelect(null);
    }
    // this.context.configStore.addFieldToLayout(item.code);
    // console.log('select',item);
  }
  isFieldInList() {
    return false;
  }
  renderList() {
    const ret=[];
    this.state.filtered_fields.forEach((item,index)=>{
      ret.push(
        <div onClick={()=>{ if(!this.isFieldInList(item)) { this.selectItem(item); } }} onMouseEnter={()=>{ if(!this.isFieldInList(item)) { this.setState({ select_index:parseInt(index) }) } }} key={index} className={`listItem hpadd10 vpadd5 ${this.state.select_index == index?'bg-pc1 w1':null} ${this.isFieldInList(item)?'op50':''} `}>
          {this.props.visible_fields?(
            <div>
              {this.props.visible_fields.map((code,index)=>{
                if(item[code]) {
                  return <div key={index} className={`${index !== 0 ? 'op50 fs12' : ''}`}>{item[code]}</div>
                }
                return null;
              })}
            </div>
          ):item.name}
        </div>
      );
    });
    if(!this.state.fetching && this.state.filtered_fields.length===0 && this.state.search ) {
      return (
        <>
          <div className="w4 padd5">
            Ничего не найдено
          </div>
          {this.props.onSelectId && this.isNumeric(this.state.search)?(
            <div className="w4 hpadd5 pbottom5">
              Нажмите enter для поиска по ID.
            </div>
          ):null}
        </>
      )
    }
    if(typeof this.props.filterFunction !== 'undefined' && !this.state.search && this.props.helperOnBlank) {
      return (
        <div className="w4 padd5">
          {this.props.helperOnBlank}
        </div>
      )
    }
    return (
      <div>{ret}</div>
    );

  }
  isNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
  }
  onKeyUp(e) {
    if(e.which ==  8) {
      if(!this.state.search) {
        e.preventDefault();
        e.stopPropagation();
        if (this.props.onCancel) {
          this.props.onCancel();
        }
      }
    }
    if(e.which == 38 || e.which == 40  || e.which == 13) {
      e.preventDefault();
      e.stopPropagation();
      let needSelect = this.state.select_index;
      let moveTo='';
      switch (e.which) {
        case 38: //up
          moveTo='up';
          needSelect--;
          break;
        case 40: //down
          moveTo='down';
          needSelect++;
          break;
        case 13:
          if(this.state.select_index !== -1) {
            this.selectItem(this.state.filtered_fields[this.state.select_index]);
          } else {
            if(this.isNumeric(this.state.search)) {
              if(this.props.onSelectId) {
                this.props.onSelectId(this.state.search);
                if(this._autosizeInputRef) {
                  this.inputRef(this._autosizeInputRef);
                }
              }
            }
          }
          break;
      }
      if (needSelect < 0) {
        needSelect = this.state.filtered_fields.length - 1;
      }
      if (needSelect > this.state.filtered_fields.length - 1) {
        needSelect = 0;
      }

      let resetWas=false;
      while(this.isFieldInList(this.state.filtered_fields[needSelect])) {
        if(moveTo === 'down') {
          needSelect++;
        }
        if(moveTo === 'up') {
          needSelect--;
        }
        if (needSelect < 0) {
          if(resetWas) {
            needSelect=-1;
            break;
          }
          needSelect = this.state.filtered_fields.length - 1;
          resetWas=true;
        }
        if (needSelect > this.state.filtered_fields.length - 1) {
          if(resetWas) {
            needSelect = -1;
            break;
          }
          needSelect = 0;
          resetWas=true;
        }
      }

      this.setState({select_index: needSelect});
      if(needSelect!==-1) {
        this.scrollToIfNotVisible(this._scrollReff, this._scrollReff.querySelectorAll('.listItem')[needSelect]);
      }
      // console.log(this._scrollReff.querySelectorAll('.listItem')[needSelect]);

      // console.log('itemRect',itemRect.y-rect.y);
      // this._scrollReff.querySelectorAll('.listItem')[needSelect].scrollIntoView({ block: "nearest" });
    }
  }
  scrollToIfNotVisible(scrollerOb,itemOb) {
    if(!scrollerOb || !itemOb) {
      return false;
    }
    const rect = scrollerOb.getBoundingClientRect();
    const rectScrollTop = scrollerOb.scrollTop;
    const height = scrollerOb.clientHeight;
    const itemRect = itemOb.getBoundingClientRect();
    const diff = itemRect.y - rect.y;
    if(diff<0 || diff+itemOb.clientHeight > scrollerOb.clientHeight) {
      const relPos = diff + rectScrollTop;
      scrollerOb.scrollTop = relPos - (height / 2) + (itemOb.clientHeight/2);
    }
  }
  getRenderedValue() {
    if(this.isListVisible() && this.props.relative) {
      return null;
    }
    let sel=null;
    if(this.state.fields && this.state.fields.length) {
      sel = this.state.fields.filter((item) => {
        return item[this.getIdField()] == this.state.selected_value;
      })[0];
    }
    if(typeof this.props.titleValue !== 'undefined') {

    }
    return (
      <div className="up12 splice">
        <div className="cell s-shrink">
          <AutosizeInput
            inputRef={(ref) => {
              this._autosizeInputRef=ref;
              this.inputRef(ref);
            }}
            inputStyle={{ maxWidth:150 }}
            onKeyDown={(e) => {
              if(this.props.onLock) {
                if (e.shiftKey && e.ctrlKey && e.which == 76 && this.state.selected_value) {
                  e.preventDefault();
                  e.stopPropagation();
                  this.props.onLock();
                }
              }

              if(e.which === 8) {
                // this.setState({ selected_value:null, sel_setted:null })
                this.selectItem(null);
                e.preventDefault();
                e.stopPropagation();
              }
              if (e.which === 191 || e.which === 220) {
                e.preventDefault();
                e.stopPropagation();
                this.props.onNewFied();
              }
            }}
            type="text"
            inputClassName="small"
            placeholder={""}
            value={sel?sel[this.getTitleField()]:(typeof this.props.titleValue !== 'undefined'?this.props.titleValue:'')}
            onChange={(e)=>{  }}
          />
        </div>
        <div className={`cell s-shrink s-middle fs11 ${(sel && sel.id) || this.props.idValue ? 'pleft5':''}`}>
          {sel?sel.id:(this.props.idValue?this.props.idValue:'')}
        </div>
      </div>
    )
  }
  inputRef(ref) {
    if(this.props.inputRef) {
      this.props.inputRef(ref);
    }
  }
  isListVisible() {
    return this.state.selected_value || this.props.selected_value?false:true;
  }
  render() {
    return (
      <div className="pr">
        {this.getRenderedValue()}
        {this.isListVisible()?(
          <div className={`bg-w1  ${this.props.relative?"pr":"shadow pa pa-tl"}`} style={{zIndex:20}}>
            <div className={`${this.props.relative?'':'padd5'} pr z3 bg-w1`}>
              {this.state.selected_value}
              <input ref={(ref)=>{
                if(!this.state.selected_value) {
                  this.inputRef(ref);
                }
              }}
                 onKeyDown={(e)=>{
                   this.onKeyUp(e);
                 }}
                 autoFocus={true} className="small w100" type="text" value={this.state.search} onChange={(e)=>{
                    if(this.props.onBeforeChange) {
                      this.props.onBeforeChange(e);
                    }
                    this.setState({ search:e.target.value });
                 }}
                 onFocus={()=>{
                   if(this.props.relative) {
                     clearTimeout(this._taSelector);
                     this.setState({focus_selector: true})
                   }
                 }}
                 onBlur={()=>{
                   if(this.props.relative) {
                     this._taSelector = setTimeout(() => {
                       this.setState({focus_selector: false})
                     }, 200);
                   }
                 }}

              />
              {this.state.fetching || this.props.fetching?(
                <div className="pa" style={{top:7,right:5}}><i className="mdi lh10 db mdi-loading mdi-spin fs20 b1"></i></div>
              ):null}
            </div>
            {this.state.focus_selector || !this.props.relative?(
              <div className={`ofa bg-w1 ${this.props.relative?'shadow':''}`} ref={(ref)=>{ this._scrollReff=ref; }} style={{width:200, maxHeight: 200, ...this.props.relative?{ position:'absolute', left:0, top:'100%', width:'100%' }:{}   }}>
                {this.renderList()}
              </div>
            ):null}
          </div>
        ):null}
      </div>
    )
  }
}

// export default inject("configStore")(observer(ListSelector));
export default observer(ListSelector);